/*! Wi-layout - v0.0.1
 * https://www.wicode.pl/
 * Copyright (c) 2017 Wicode; */

function sprintf(str, ...args) {
    let i = 0;
    return str.replace(/%[sd]/g, () => args[i++]);
}

+function ($) {
    'use strict';
    var wiLayout = window.wiLayout;

    var htmls = {
        loader: '<div id="loader"><div class="spinner"><div class="bounce1"></div><div class="bounce2"></div><div class="bounce3"></div></div></div>',
        toTop: '<button id="back-to-top" rel="nofollow" class="btn back-to-top" role="button"><span class="fa fa-angle-up"></span></button>',
        cookies: '<div class="alert alert-cookie alert-dismissible" role="alert" id="cookie"> <div class="container"> <div class="col-xs-12 col-sm-10"> <p>' + lang['cookie_info'] + ' <a href="' + lang['url-lang'] + '/' + lang['url-cookies'] + '" class="cookie alert-link" rel="nofollow">' + lang['cookie_link'] + '</a></p> </div> <div class="col-xs-12 col-sm-2 text-right"> <button type="button" class="btn btn-cookie-ok btn-equal" data-dismiss="alert" id="cookie-ok" aria-label="' + lang['cookie_accept'] + '"><i class="fa fa-check" aria-hidden="true"></i></button> <button type="button" class="btn btn-cookie-x btn-equal" data-dismiss="alert" id="cookie-x" aria-label="' + lang['cookie_close'] + '"><i class="fa fa-times" aria-hidden="true"></i></button></div> </div> </div>'
    };
    var didFooterResize = false;

    window.wiLayout = {
        init: function () {
            wiLayout.bootstrap();
            wiLayout.cookies();
            wiLayout.comments();
            wiLayout.scroll.init();
            wiLayout.footer.init();
        },
        refresh: function () {
        },
        events: function () {
        },
        bootstrap: function () {
            $("[data-toggle='tooltip']").tooltip({
                container: 'body'
            });
            $("[data-toggle='popover']").popover({
                trigger: 'hover',
                container: 'body'
            });
        },
        comments: function () {
            if ($('#comments_area').length) {
                wiComments.get.comments();
            }
        },
        cookies: function () {
            if ($.cookie("cookie-alert") === "ok") {
                if ($("#cookie").length) {
                    $("#cookie").fadeOut();
                    $("#cookie").remove();
                }
            } else {
                $("body").append(htmls.cookies);
                $('#cookie').fadeIn('slow');
                $("#cookie-x").click(function (e) {
                    e.preventDefault();
                    $("#cookie").fadeOut();
                    $("#cookie").remove();
                    $.cookie("cookie-alert", null);
                });
                $("#cookie-ok").click(function (e) {
                    e.preventDefault();
                    $("#cookie").fadeOut();
                    $("#cookie").remove();
                    $.cookie("cookie-alert", "ok", {expires: 7});
                });
            }

        },
        loader: function (action) {
            if (action === 'show') {
                $('body').append(htmls.loader);
            } else {
                $('#loader').remove();
            }
        },
        scroll: {
            init: function () {
                $("body").append(htmls.toTop);
                $(window).scroll(function () {
                    if ($(this).scrollTop() > 50) {
                        $('#back-to-top').fadeIn();
                    } else {
                        $('#back-to-top').fadeOut();
                    }
                });
                $(document).on('click', '#back-to-top', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    $(this).tooltip('hide');
                    $('body,html').animate({scrollTop: 0}, 800);
                    return false;
                });
            },
            to: function (scrollToElem) {
                if (scrollToElem && $(scrollToElem)) {
                    $('body,html').animate({scrollTop: ($(scrollToElem).offset().top - 120)}, 800);
                }
            },
            progress: function () {
                $(document).scroll(function (e) {
                    var scrollAmount = $(window).scrollTop();
                    var documentHeight = $(document).height();
                    var windowHeight = $(window).height();
                    var scrollPercent = (scrollAmount / (documentHeight - windowHeight)) * 100;
                    $(".wi-progress").css("width", (scrollPercent + '%'));
                });
            }

        },
        footer: {
            init: function () {
                wiLayout.footer.resize();
                wiLayout.footer.stickyFooter();
                setInterval(function () {
                    if (didFooterResize) {
                        didFooterResize = false;
                        wiLayout.footer.stickyFooter();
                    }
                }, 250);
            },
            stickyFooter: function () {
                $('body').css('padding-bottom', $('footer').height());
            },
            resize: function () {
                $(window).resize(function () {
                    didFooterResize = true;
                });
            }
        }
    };
    $(function () {
        wiLayout = window.wiLayout;
        wiLayout.init();
    });
}(jQuery);
